import axios from 'axios'
import baseUrl from '../config.json'
export const loginUser = userData => {
  axios
    .post(baseUrl.apiEndPoint+'/api/auth/signin', userData)
    .then(res => {
        console.log(res.data)
      if (res.data.accessToken !=null) {
          console.log(res.data.id)
        localStorage.setItem('userid',res.data.id)
        localStorage.setItem('role',res.data.roles)
        localStorage.setItem('username',userData.username)
        window.location.href = '/dashboard'
      }else{
        alert('Username or password incorrect')
        console.log("incorrect")
      }
    })
    .catch(err =>
      //console.log("error=",err)
      alert('Username or password incorrect')
    )
}
const api = {
  loginUser
}
export default api
